import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map, filter, includes } from 'lodash';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { CallWidgetCategoryReasonSummary } from 'ui/containers/CallWidgetCategoryReasonSummary';
import { CallWidgetActivity } from 'ui/containers/CallWidgetActivity';
import { CallItemNotesWidget } from 'ui/containers/CallItemNotesWidget';

const WIDGET_VIEWS = {
    [ WIDGET_NAMES.CALL_DETAIL_TABS_INNER_WIDGET_CATEGORY_REASON ]: CallWidgetCategoryReasonSummary,
    [ WIDGET_NAMES.CALL_DETAIL_TABS_INNER_WIDGET_ACTIVITY ]: CallWidgetActivity,
    [ WIDGET_NAMES.CALL_ITEM_NOTES ]: CallItemNotesWidget
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callItemDetailInnerWidget as CallItemDetailInnerWidget } from 'ui/views/widgets/callItemDetailInnerWidget';
 *
 * // render
 * <CallItemDetailInnerWidget propName='propValue'/>
 */
export const callItemDetailInnerWidgetSuccess = ( props ) => {

    // extract left and right widgets
    const leftWidgets = filter( props.widgets, widget => includes( [ 'callWidgetCategoryReason', 'callWidgetActivity' ], widget.name ) );
    const rightWidgets = filter( props.widgets, widget => includes( [ 'callItemNotes' ], widget.name ) );
    
    return (
        <div className='ui-call-item-detail-inner-widget'>

            {/* left widgets */}
            <div className='ui-call-item-detail-inner-widget__left'>
                {
                    map( leftWidgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        return (
                            <div key={ widget.name } className='ui-call-item-detail-inner-widget__left__widget'>
                                <WidgetView
                                    widget={ widget }
                                    callId={ props.callId }
                                    requestPayload={ props.requestPayload }
                                />
                            </div>
                        );
                    } )
                }
            </div>

            {/* right widgets */}
            <div className='ui-call-item-detail-inner-widget__right'>
                {
                    map( rightWidgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        return (
                            <div key={ widget.name } className='ui-call-item-detail-inner-widget__right__widget'>
                                <WidgetView
                                    widget={ widget }
                                    callId={ props.callId }
                                    requestPayload={ props.requestPayload }
                                 />
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
callItemDetailInnerWidgetSuccess.displayName = 'callItemDetailInnerWidgetSuccess';

// set default props
callItemDetailInnerWidgetSuccess.defaultProps = {};

// prop types
callItemDetailInnerWidgetSuccess.propTypes = {};

// Preloader view
export const callItemDetailInnerWidgetPreloader = () => {
    return (
        <div className='ui-call-item-detail-inner-widget__pagination-spinner'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
callItemDetailInnerWidgetPreloader.displayName = 'callItemDetailInnerWidgetPreloader';

// set default props
callItemDetailInnerWidgetPreloader.defaultProps = {};

// prop types
callItemDetailInnerWidgetPreloader.propTypes = {};

export const callItemDetailInnerWidget = withNetworkState( callItemDetailInnerWidgetPreloader, callItemDetailInnerWidgetSuccess );
